export default "__VITE_ASSET__BVR7uOtP__"